import React from 'react';
import { Card,Form } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

import { useState } from 'react';
import { getDashboard_supportServicesTable_Line } from 'functions/dashboard';
import { useEffect } from 'react';
import SupportServicesTreandLineDate from './support-services-line-date/AverageEnrollment';
import moment from 'moment';

const SupportServicesTreadlineDate = ({fromDate, toDate, companyId}) => {

useEffect(()=>{
loadTableData_Date(fromDate, toDate, companyId)
}
,[fromDate, toDate, companyId])

const loadTableData_Date = async(fromDate, toDate, companyId)=>{
  try {
  const data = {
    fromDate,
    toDate,
    type: 'date'
  , companyId: companyId ? companyId : null
  };  
  
  const token=localStorage.getItem('token');
 const tableDataO=await getDashboard_supportServicesTable_Line(data,token);
// console.log('taaaaa',tableDataO);

 if (tableDataO.recordsets && Array.isArray(tableDataO.recordsets)) {
   const transformedData = tableDataO.recordsets.flat().map(item => ({
     id: item.groupby,
     date: item.groupby,
     totalSupportCalls: item.totalTickets,
     resolved: item.totalTicketsResolved,
     permanentlyResolved: item.totalTicketsPermenentlyResolved,
     temporaryResolved: item.totalTicketsTemporaryResolved,
     pending: item.totalTicketsPending
   }));

   setTableData(transformedData.filter(item => item.totalSupportCalls > 0));
 }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
  }




   const [tableData,setTableData] =useState([
    {
      // id: 1,
      // date: '30.10.2023',
      // totalSupportCalls: 10,
      // resolved: 9,
      // permanentlyResolved: 7,
      // temporaryResolved: 2,
      // pending:1
    },
   
  ]);


  return (
    <Card className="overflow-hidden">
      <FalconCardHeader 
      title={`Support Services - Date | ${moment(fromDate).format('yyyy MMM DD hh:mm a')} - ${moment(toDate).format('yyyy MMM DD')}`}
       titleTag="h6" />
      <Card.Body className="p-0">
        <SupportServicesTreandLineDate data={tableData}  />
      </Card.Body>
    </Card>
  );
};

export default SupportServicesTreadlineDate;
